import { useEffect, useState } from "react";
import { errorHandler, HandledHTTPError, isHTTPError, HTTPError } from "@evergis/api";

export const useHttpErrorHandled = (
  error: Error | undefined,
): [HandledHTTPError<HTTPError>, (error: HandledHTTPError<HTTPError> | null) => void] => {
  const [handledError, setHandledError] = useState<HandledHTTPError<HTTPError>>(null);

  useEffect(() => {
    if (error && !handledError) {
      const handled = errorHandler<Error>(error);

      if (isHTTPError(handled)) {
        setHandledError(handled);
      }
    }
  }, [error]);

  return [handledError, setHandledError];
};
